'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPDATE_VIEW = exports.UPDATE_VIEW = 'UPDATE_VIEW';


//////////////////
// WEBPACK FOOTER
// ./js/current-view/constants/actionTypes.js
// module id = 619
// module chunks = 2 3